'use strict';

var isDefined = require('./is-defined');

/**
 * Verifica se una variabile è definita e strettamente diversa da null.
 * @param mixed
 * @returns {boolean}
 */
module.exports = function isDefinedAndNotNull(mixed) {
    return isDefined(mixed) && mixed !== null;
};
